import { Expose, Type } from 'class-transformer';
import { Country } from './country.model';
import { DropdownModel } from '@shared/models/dropdown-model.model';

export class City extends DropdownModel {
  @Expose() id: number;
  @Expose() isoCode?: string;
  @Expose() name?: string;
  @Expose() status?: string;
  @Expose() polygonCoordinates?: string;
  selectedBy?: number = null;
  @Expose() isUnknown?: boolean;
  @Expose() bayanCityId?: number;
  @Expose() @Type(() => Country) country?: Country;

  get dropDownDisplayName(): string {
    return this.name;
  }

  get dropDownValue(): Object {
    return this;
  }
}
